<template>
  <div class="checkbox" @click.stop>
    <input type="checkbox" :id='"toggleLabel_" + label' v-model='checkboxState' :class='{partial: !checkboxState && headingStateObject.countSelected > 0}'>
    <label :for='"toggleLabel_" + label'>{{ label }}</label>
  </div>
</template>

<script>
export default {
  name: 'partialCheckbox',
  props: ['label', 'value', 'headingStateObject'],
  data () {
    return {
      checkboxState: null,
      dontEmitForThis: false,
      fullyMounted: false // Otherwise the watch make it emit on open
    }
  },
  mounted: function () {
    this.checkboxState = this.value
  },
  watch: {
    checkboxState: function () {
      console.log('Changed the checkbox')
      if (!this.dontEmitForThis && this.fullyMounted) {
        console.log('Emitting the change')
        this.$emit('change', {
          state: this.checkboxState,
          headingStateObject: this.headingStateObject
        })
      } else {
        this.dontEmitForThis = false
        this.fullyMounted = true
      }
    },
    value: function () {
      if (!this.value && this.headingStateObject.countSelected > 0) {
        this.dontEmitForThis = true // This is because otherwise deselecting one item deselects all
      }
      this.checkboxState = this.value
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/partialCheckbox.vue